// extracted by mini-css-extract-plugin
module.exports = {"main":"star_main__4EpUt","atv":"star_atv__fOEE_"};